// Export all error configurations
import { updatePasswordAuthErrorConfig } from './authentication/updatePasswordAuthErrorConfig';
import { generalAuthErrorConfig } from './general/generalAuthErrorConfig';
import { signInAuthErrorConfig } from './authentication/signInAuthErrorConfig';
import { otpAuthErrorConfig } from './authentication/otpAuthErrorConfig';

/**
 * Pre-configured error configurations for common operations
 */
export const errorConfigs = {
    updatePassword: updatePasswordAuthErrorConfig,
    signIn: signInAuthErrorConfig,
    otp: otpAuthErrorConfig,
    general: generalAuthErrorConfig,
} as const;
